var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLining = function SvgLining(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8 2 22m15.5-7H9m3.7 4c.5 0 1-.2 1.4-.6l6.2-6.2c2.3-2.3 2.3-6.1 0-8.5-2.3-2.3-6.1-2.3-8.5 0L5.6 9.9c-.4.4-.6.9-.6 1.4V18c0 .6.4 1 1 1h6.7Z",
    stroke: "#00344E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgLining as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDcuOTk5NjFMMiAyMS45OTk2TTE3LjUgMTQuOTk5Nkg5TTEyLjcgMTguOTk5NkMxMy4yIDE4Ljk5OTYgMTMuNyAxOC43OTk2IDE0LjEgMTguMzk5NkwyMC4zIDEyLjE5OTZDMjIuNiA5Ljg5OTYxIDIyLjYgNi4wOTk2MSAyMC4zIDMuNjk5NjFDMTggMS4zOTk2MSAxNC4yIDEuMzk5NjEgMTEuOCAzLjY5OTYxTDUuNiA5Ljg5OTYxQzUuMiAxMC4yOTk2IDUgMTAuNzk5NiA1IDExLjI5OTZWMTcuOTk5NkM1IDE4LjU5OTYgNS40IDE4Ljk5OTYgNiAxOC45OTk2SDEyLjdaIiBzdHJva2U9IiMwMDM0NEUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";